import { useEffect, useState } from 'react'
import { pixelateImage, MimeType } from '@helpers/pixelate'

export const usePixelateImage = (src?: string, mimeType?: MimeType, pixelSize?: number) => {
  const [pixelatedSource, setPixelatedSource] = useState<string | undefined>(src)

  useEffect(() => {
    if (src) {
      pixelateImage(src, mimeType, pixelSize).then((pixelatedSource) => {
        setPixelatedSource(pixelatedSource)
      })
    }
  }, [src])

  return pixelatedSource
}
